export const GET_CREDITS = "GET_CREDITS";
export const GET_CREDIT_BY_ID = "GET_CREDIT_BY_ID";
export const UPDATE_CREDIT = "UPDATE_CREDIT";
export const DELETE_CREDIT = "DELETE_CREDIT";
export const CREATE_CREDIT = "CREATE_CREDIT";
